





























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'

@Component({
  components: {
    CopyableText,
    BaseButton
  }
})
export default class AdminDepartmentChatId extends Vue {
  @Prop({ default: 'sm' }) iconSize: string
  @Prop({ required: true }) telegramActivationCode: string
  @Prop() chatId: string

  protected get slotProps() {
    return {
      chatId: this.chatId,
      telegramActivationCode: this.telegramActivationCode
    }
  }

  get setDepartmentCode() {
    return '/setDepartment ' + this.telegramActivationCode
  }
}
